/* Signage.inc redesign - site scripts (no dependencies): mobile nav, reveal on scroll, contact form, sliders. */
(function () {
  'use strict';
  var doc = document;
  doc.documentElement.classList.add('js');

  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var SG = window.SG || {};

  /* ---- mobile nav ---- */
  var burger = $('.site-header .burger'), nav = $('#nav'), scrim = $('.scrim');
  function setNav(open) {
    if (!burger || !nav) return;
    nav.classList.toggle('open', open);
    if (scrim) scrim.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    doc.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && nav) {
    burger.addEventListener('click', function () { setNav(!nav.classList.contains('open')); });
    if (scrim) scrim.addEventListener('click', function () { setNav(false); });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', function () { setNav(false); }); });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('open')) { setNav(false); burger.focus(); }
    });
  }

  /* ---- reveal on scroll (also picks up elements added later, e.g. rendered sign cards) ---- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
  function reveal(root) {
    $$('.rv:not(.in)', root).forEach(function (el) { if (io) io.observe(el); else el.classList.add('in'); });
  }
  reveal(doc);
  window.SGReveal = reveal;
  /* theme editor: re-run when a section is added or changed */
  doc.addEventListener('shopify:section:load', function (e) { reveal(e.target); initSliders(e.target); });

  /* ---- contact form (form[data-sg-contact]) ----
     Posts JSON to the contact API (SGLead.contact), like the Signs.inc contact form
     (signs.inc sections/nt-contact-form-v1.liquid): mockup photos upload the moment they are picked
     (several files, each removable, live progress) and their URLs go in `images`. */
  var CONTACT_TYPES = {
    general: 'General Inquiry', mockup: 'Request Mockup', order: 'Order / Support', trade: 'Trade / Partner',
    warranty: 'Warranty & Returns', consultation: 'Consultation', question: 'Ask a Question'
  };
  var IMAGE_UPLOAD_URL = 'https://imagescloudv2.codeblue.agency/api/image/upload';
  var MAX_IMAGE_SIZE = 20 * 1024 * 1024;
  function fieldWrap(el) { return el.closest('.fld'); }
  function escHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function badField(el, bad) {
    var w = fieldWrap(el); if (w) w.classList.toggle('bad', bad);
    el.setAttribute('aria-invalid', bad ? 'true' : 'false');
  }
  /* every problem is flagged at once; focus goes to the first one */
  function validate(form, extra) {
    var first = null;
    $$('input,select,textarea', form).forEach(function (el) {
      if (el.disabled || el.type === 'file' || el.type === 'hidden') return;
      var v = (el.value || '').trim(), bad = el.required && !v;
      if (!bad && v && el.type === 'email') bad = !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v);
      if (!bad && v && el.type === 'tel') { var d = v.replace(/\D/g, ''); bad = !(d.length === 10 || (d.length === 11 && d.charAt(0) === '1')); }
      if (!bad && el.required && el.name === 'name') bad = v.length < 2;
      badField(el, bad);
      if (bad) first = first || el;
    });
    if (extra) { var x = extra(); if (x) first = first || x; }
    if (first) first.focus();
    return !first;
  }
  $$('form[data-sg-contact]').forEach(function (form) {
    var status = $('.form-status', form), btn = $('button[type=submit]', form);
    $$('input,select,textarea', form).forEach(function (el) {
      el.addEventListener('input', function () { var w = fieldWrap(el); if (w) w.classList.remove('bad'); });
    });
    function val(n) { var el = form.elements[n]; return el && !el.disabled ? (el.value || '').trim() : ''; }
    var contactUuid = window.SGLead && window.SGLead.newUuid ? window.SGLead.newUuid() : '';

    /* sign type list comes from the single category file (assets/sg-sign-categories.js) */
    var stSel = $('[data-sg-sign-types]', form), cats = (window.SG_SIGN_DATA || {}).categories || [];
    if (stSel) cats.forEach(function (c) { var o = doc.createElement('option'); o.textContent = c.name; stSel.appendChild(o); });

    /* ---- mockup photos: several files, uploaded instantly ---- */
    var dz = $('.drop-zone', form), fi = dz && $('input[type=file]', dz), fn = dz && $('.fname', dz);
    var upWrap = $('.ct-up', form), upBar = upWrap && $('.ct-up-bar i', upWrap), upLabel = upWrap && $('.ct-up-l', upWrap), fList = $('.ct-files', form);
    var files = [];        /* { file, status: uploading|done|error, url } */
    var inFlight = 0;
    function uploadedUrls() { return files.filter(function (x) { return x.status === 'done' && x.url; }).map(function (x) { return x.url; }); }
    function renderFiles() {
      if (!fList) return;
      var up = files.some(function (x) { return x.status === 'uploading'; }), bad = files.some(function (x) { return x.status === 'error'; });
      if (fn) fn.textContent = !files.length ? '' : up ? 'Uploading…' : bad ? 'Some files did not upload. Remove them or try again.' : (files.length === 1 ? '1 file ready' : files.length + ' files ready');
      fList.innerHTML = files.map(function (x, i) {
        var cls = x.status === 'done' ? 'ok' : x.status === 'error' ? 'bad' : '';
        var txt = x.status === 'done' ? 'Ready' : x.status === 'error' ? 'Upload failed' : 'Uploading…';
        return '<li><span class="ct-f-n">' + escHtml(x.file.name) + '</span><span class="ct-f-s ' + cls + '">' + txt + '</span>' +
          '<button type="button" data-remove="' + i + '" aria-label="Remove ' + escHtml(x.file.name) + '">&times;</button></li>';
      }).join('');
    }
    function setUploading(delta) {
      inFlight = Math.max(0, inFlight + delta);
      if (upWrap) upWrap.classList.toggle('on', inFlight > 0);
    }
    function upload(batch) {
      batch.forEach(function (x) { x.status = 'uploading'; });
      renderFiles(); setUploading(1);
      if (upBar) upBar.style.width = '0%';
      if (upLabel) upLabel.textContent = 'Uploading… 0%';
      var fd = new FormData();
      fd.append('name', val('name') || 'contact');
      fd.append('page_url', location.href);
      fd.append('uuid', contactUuid);
      batch.forEach(function (x) { fd.append('images[]', x.file); });
      function done() { setUploading(-1); renderFiles(); prospectSchedule(); }
      function fail() { batch.forEach(function (x) { if (x.status !== 'done') x.status = 'error'; }); done(); }
      var xhr = new XMLHttpRequest();
      xhr.timeout = 60000;
      xhr.upload.onprogress = function (ev) {
        if (!ev.lengthComputable) return;
        var pct = Math.round(ev.loaded / ev.total * 100);
        if (upBar) upBar.style.width = pct + '%';
        if (upLabel) upLabel.textContent = 'Uploading… ' + pct + '%';
      };
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) { fail(); return; }
        var urls = [];
        try { urls = (JSON.parse(xhr.responseText) || {}).imageUrls || []; } catch (e) { }
        batch.forEach(function (x, i) { if (urls[i]) { x.status = 'done'; x.url = urls[i]; } else x.status = 'error'; });
        done();
      };
      xhr.onerror = fail; xhr.ontimeout = fail;
      xhr.open('POST', IMAGE_UPLOAD_URL, true);
      xhr.send(fd);
    }
    function addFiles(list) {
      var incoming = Array.prototype.slice.call(list || []), big = [], batch = [];
      incoming.forEach(function (f) {
        if (f.size > MAX_IMAGE_SIZE) { big.push(f); return; }
        if (files.some(function (x) { return x.file.name === f.name && x.file.size === f.size && x.file.lastModified === f.lastModified; })) return;
        var x = { file: f, status: 'uploading', url: '' }; files.push(x); batch.push(x);
      });
      if (batch.length) { var w = fieldWrap(fi); if (w) w.classList.remove('bad'); upload(batch); }
      if (big.length && fn) fn.textContent = big.length === 1 ? '"' + big[0].name + '" is over 20 MB. Please choose a smaller file.' : big.length + ' files are over 20 MB and were skipped.';
      fi.value = '';
    }
    function waitUploads() {
      return new Promise(function (resolve) {
        if (!inFlight) { resolve(); return; }
        var iv = setInterval(function () { if (!inFlight) { clearInterval(iv); resolve(); } }, 200);
      });
    }
    function clearFiles() { files = []; renderFiles(); }
    if (dz) {
      fi.addEventListener('change', function () { addFiles(fi.files); });
      ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('over'); }); });
      dz.addEventListener('drop', function (e) { if (e.dataTransfer.files.length && !fi.disabled) addFiles(e.dataTransfer.files); });
    }
    if (fList) fList.addEventListener('click', function (e) {
      var b = e.target.closest('[data-remove]'); if (!b) return;
      files.splice(parseInt(b.getAttribute('data-remove'), 10), 1); renderFiles(); prospectSchedule();
    });

    /* topic picker: list and tiles stay in sync; each topic shows its own extra fields */
    var topicIn = $('#c-topic', form), msg = $('#c-msg', form), sendBtn = $('.ct-send', form);
    var pickers = $$('.ct-item,.ct-tile');
    var key = 'general';
    function pick(name) {
      var src = pickers.filter(function (b) { return b.getAttribute('data-topic') === name; })[0];
      if (!src) return;
      key = src.getAttribute('data-key') || 'general';
      if (topicIn) topicIn.value = name;
      pickers.forEach(function (b) { var on = b.getAttribute('data-topic') === name; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      $$('.ct-x', form).forEach(function (w) {
        var forKeys = w.getAttribute('data-for'), notKeys = w.getAttribute('data-not');
        var show = forKeys ? forKeys.split(' ').indexOf(key) > -1 : !(notKeys && notKeys.split(' ').indexOf(key) > -1);
        w.hidden = !show;
        if (!show) w.classList.remove('bad');
        $$('input,select', w).forEach(function (el) { el.disabled = !show; });
      });
      if (msg && src.getAttribute('data-ph')) msg.placeholder = src.getAttribute('data-ph');
      if (sendBtn && src.getAttribute('data-btn')) sendBtn.firstChild.nodeValue = src.getAttribute('data-btn') + ' ';
    }
    pickers.forEach(function (b) { b.addEventListener('click', function () { pick(b.getAttribute('data-topic')); prospectSchedule(); }); });
    form.addEventListener('reset', function () { setTimeout(function () { if (topicIn) pick(topicIn.value); clearFiles(); }, 0); });
    if (topicIn && pickers.length) pick(topicIn.value);

    /* the contact API payload for the current topic (same keys for the prospect and the real submission) */
    function buildFields() {
      var fields = {
        uuid: contactUuid, type: CONTACT_TYPES[key] || val('topic'),
        name: val('name'), email: val('email'), phone: val('phone'), business: val('business'), message: val('message')
      };
      if (key === 'mockup') { fields.sign_type = val('sign_type'); fields.size = val('size'); fields.images = uploadedUrls(); }
      else if (key === 'order' || key === 'warranty') fields.order_number = val('order_number');
      else if (key === 'consultation') { fields.consult_topic = val('consult_topic'); fields.preferred_time = val('preferred_time'); }
      else if (key === 'question') fields.question_topic = val('question_topic');
      return fields;
    }

    /* ---- prospect: what the visitor has typed, saved before they send the form ----
       POST {SG.endpoints.contactProspect} creates the record as soon as there is something to save and answers
       with its Airtable record id; every later change is a PATCH to {endpoint}/{airtableRecordId} (the uuid when
       Airtable was down at create time). Debounced while typing, flushed when the tab is hidden or the page is
       left, paused while the real form is sending. The real submission carries prospect_airtable_id so the API
       marks the prospect as submitted; after it a fresh prospect starts for the next message. */
    var PROSPECT_URL = (SG.endpoints && SG.endpoints.contactProspect) || '';
    var pr = { gen: 0, created: false, creating: false, dirty: false, airtableId: '', last: '', timer: null, sending: false };
    function lsGet(k) { try { return (window.safeLocalStorage || localStorage).getItem(k) || ''; } catch (e) { return ''; } }
    function prospectPayload() {
      var f = buildFields();
      if (f.phone && window.SGLead && window.SGLead.phoneUS) f.phone = window.SGLead.phoneUS(f.phone);
      f.lead_page_url = location.href;
      f.location = lsGet('location') || lsGet('ev_location_and_time');
      f.journeyCountry = lsGet('countryName');
      if (window.SGLead && window.SGLead.tracking) { var tr = window.SGLead.tracking(); Object.keys(tr).forEach(function (k) { f[k] = tr[k]; }); }
      return f;
    }
    function prospectHasData(f) {
      return ['name', 'email', 'phone', 'business', 'message', 'size', 'order_number',
        'sign_type', 'consult_topic', 'preferred_time', 'question_topic'].some(function (k) { return f[k]; }) ||
        !!(f.images && f.images.length);
    }
    function prospectSync(leaving) {
      clearTimeout(pr.timer);
      if (!PROSPECT_URL || pr.sending) return;
      var f = prospectPayload();
      if (!prospectHasData(f)) return;
      var body = JSON.stringify(f);
      if (body === pr.last) return;                                      /* nothing new since the last save */
      var create = !pr.created, gen = pr.gen;
      var url = create ? PROSPECT_URL : PROSPECT_URL + '/' + encodeURIComponent(pr.airtableId || contactUuid);
      /* tab hidden / page closing: a JSON or PATCH request needs a CORS preflight, which a closing page cannot
         wait for, so it goes as a beacon with plain form data (a PATCH as POST + _method=PATCH, as Laravel reads it).
         A create sent this way is answered nowhere: later changes PATCH by the uuid, which the API also accepts. */
      if (leaving && navigator.sendBeacon && !pr.creating) {
        var params = new URLSearchParams();
        Object.keys(f).forEach(function (k) {
          if (Array.isArray(f[k])) f[k].forEach(function (v) { params.append(k + '[]', v); });
          else if (f[k] != null) params.append(k, f[k]);
        });
        if (!create) params.append('_method', 'PATCH');
        if (navigator.sendBeacon(url, params)) { pr.last = body; pr.created = true; return; }
      }
      if (pr.creating) { pr.dirty = true; return; }                      /* PATCHed once the POST has answered */
      pr.last = body;
      if (create) pr.creating = true;
      fetch(url, { method: create ? 'POST' : 'PATCH', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body, keepalive: !!leaving })
        .then(function (r) { if (!r.ok) throw new Error('prospect ' + r.status); return r.json().catch(function () { return {}; }); })
        .then(function (d) {
          if (gen !== pr.gen) return;                                    /* the form was sent meanwhile */
          pr.created = true;
          if (d && d.airtableRecordId) pr.airtableId = d.airtableRecordId;
        })
        .catch(function () { if (gen === pr.gen) pr.last = ''; })        /* try again with the next change */
        .then(function () {
          if (gen !== pr.gen || !create) return;
          pr.creating = false;
          if (pr.dirty) { pr.dirty = false; prospectSync(); }
        });
    }
    function prospectSchedule() { clearTimeout(pr.timer); pr.timer = setTimeout(prospectSync, 700); }
    function prospectReset() {
      clearTimeout(pr.timer);
      pr = { gen: pr.gen + 1, created: false, creating: false, dirty: false, airtableId: '', last: '', timer: null, sending: false };
    }
    form.addEventListener('input', function (e) { if (e.target.type !== 'file') prospectSchedule(); });
    form.addEventListener('change', function (e) { if (e.target.tagName === 'SELECT') prospectSchedule(); });
    doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden') prospectSync(true); });
    window.addEventListener('pagehide', function () { prospectSync(true); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      status.className = 'form-status';
      var mockup = key === 'mockup' && fi && !fi.disabled;
      var ok = validate(form, function () {
        /* a mockup needs at least one photo or logo (uploaded, or still uploading) */
        var bad = mockup && !files.some(function (x) { return x.status !== 'error'; });
        var w = fi && fieldWrap(fi); if (w) w.classList.toggle('bad', !!bad);
        return bad ? dz : null;
      });
      if (!ok) return;
      var label = sendBtn ? sendBtn.firstChild.nodeValue : btn.textContent;
      clearTimeout(pr.timer); pr.sending = true;
      btn.disabled = true;
      if (sendBtn) sendBtn.firstChild.nodeValue = 'Sending... '; else btn.textContent = 'Sending...';
      waitUploads().then(function () {
        if (mockup && !uploadedUrls().length) {
          var w = fieldWrap(fi); if (w) w.classList.add('bad');
          throw new Error('upload');
        }
        var fields = buildFields();
        if (pr.airtableId) fields.prospect_airtable_id = pr.airtableId;   /* the API marks that prospect as submitted */
        return window.SGLead.contact(fields);
      }).then(function () {
        prospectReset();                              /* the next message is a new prospect */
        form.reset();
        contactUuid = window.SGLead.newUuid();       /* fresh identity for the next message */
        status.className = 'form-status ok';
        status.textContent = form.getAttribute('data-ok') || 'Thanks! We have your message and will reply within 2 hours.';
        status.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(function (err) {
        status.className = 'form-status fail';
        status.textContent = err && err.message === 'upload'
          ? 'Your photos did not upload. Please remove them and add them again.'
          : 'Sorry, that did not send. Please try again, or call ' + (SG.phone || '') + ' or email ' + (SG.email || '') + '.';
      }).then(function () {
        pr.sending = false;
        btn.disabled = false;
        if (sendBtn) sendBtn.firstChild.nodeValue = label; else btn.textContent = label;
      });
    });
  });

  /* ---- Loox reviews page in a lightbox: every "See the original reviews on Loox" link (loox.io/widget/.../reviews)
     opens the page in an iframe instead of leaving the site. Loox allows framing on signage.inc, the myshopify
     domain and Shopify previews (frame-ancestors); "Open in new tab" stays available. Ctrl/Cmd/middle click
     still open a new tab as usual. ---- */
  var looxDlg = null, looxLast = null;
  function looxClose() {
    if (!looxDlg || looxDlg.hidden) return;
    looxDlg.hidden = true;
    $('iframe', looxDlg).src = 'about:blank';
    if (!$('.csm:not([hidden])')) doc.body.style.overflow = '';
    if (looxLast && looxLast.focus) looxLast.focus();
  }
  function looxOpen(url) {
    if (!looxDlg) {
      looxDlg = doc.createElement('div');
      looxDlg.className = 'sg-lx';
      looxDlg.setAttribute('role', 'dialog');
      looxDlg.setAttribute('aria-modal', 'true');
      looxDlg.setAttribute('aria-label', 'Customer reviews on Loox');
      looxDlg.hidden = true;
      looxDlg.innerHTML = '<div class="sg-lx-bd"></div><div class="sg-lx-card">' +
        '<div class="sg-lx-bar"><b>Verified customer reviews</b><a class="sg-lx-ext" target="_blank" rel="noopener">Open in new tab ' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg></a>' +
        '<button type="button" class="sg-lx-x" aria-label="Close reviews"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>' +
        '<div class="sg-lx-body"><span class="sg-lx-load" aria-hidden="true"></span><iframe title="Customer reviews on Loox" loading="eager"></iframe></div></div>';
      doc.body.appendChild(looxDlg);
      $('.sg-lx-bd', looxDlg).addEventListener('click', looxClose);
      $('.sg-lx-x', looxDlg).addEventListener('click', looxClose);
      $('iframe', looxDlg).addEventListener('load', function () { looxDlg.classList.add('loaded'); });
    }
    looxLast = doc.activeElement;
    looxDlg.classList.remove('loaded');
    $('.sg-lx-ext', looxDlg).href = url;
    $('iframe', looxDlg).src = url;
    looxDlg.hidden = false;
    doc.body.style.overflow = 'hidden';
    $('.sg-lx-x', looxDlg).focus();
  }
  doc.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="loox.io/widget/"]');
    if (!a || !/\/reviews/.test(a.getAttribute('href')) || a.classList.contains('sg-lx-ext')) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    looxOpen(a.href);
  });
  /* capture phase: Esc closes the reviews first when they sit on top of the case study dialog */
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && looxDlg && !looxDlg.hidden) { e.stopImmediatePropagation(); looxClose(); }
  }, true);

  /* ---- sliders: .lp-slider > .lp-prev + .lp-track + .lp-next ---- */
  function initSliders(root) {
    $$('.lp-slider', root).forEach(function (sl) {
      if (sl.dataset.ready) return; sl.dataset.ready = '1';
      var track = $('.lp-track', sl), prev = $('.lp-prev', sl), next = $('.lp-next', sl);
      if (!track) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; }
      function sync() {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync); sync();
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { track.scrollBy({ left: step(), behavior: 'smooth' }); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { track.scrollBy({ left: -step(), behavior: 'smooth' }); e.preventDefault(); }
      });
    });
  }
  initSliders(doc);

  var yr = $('#yr'); if (yr) yr.textContent = new Date().getFullYear();
})();
